<template>
    <div class="p-user-coupons" :class="{ 'container-fluid' : !asUserProfile }">
        <div :class="{ 'row justify-content-center' : !asUserProfile }">
            <div :class="{ 'col-md-12' : !asUserProfile }">
                <div class="card">
                    <div
                        class="card-header"
                        :class="{ 'font-weight-bold' : asUserProfile }">
                        クーポン履歴<span v-if="asUserProfile" class="text-muted small">（最新15件まで）</span>
                    </div>

                    <div class="card-body p-user-coupons__content pt-2">
                        <div v-if="!asUserProfile" class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.category"
                                            @change="onChangeSearchCategory"
                                            class="form-control">
                                            <option :value="null">タイプで検索</option>
                                            <option :value="couponCategory.consultation">{{ $locale.consultation_host }}</option>
                                            <option :value="couponCategory.plan">サービス</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="search.freeword"
                                            @blur="onChangeSearchFreeword"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード"
                                            style="min-width: 100px;">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text"
                                                @click="onChangeSearchFreeword">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <span class="small">発行日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                type="date"
                                                class="form-control"
                                                @change="onChangeSearchPublishedAtGte"
                                                style="min-width: 100px;"
                                                v-model="search.published_at_gte">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                type="date"
                                                class="form-control"
                                                @change="onChangeSearchPublishedAtLte"
                                                style="min-width: 100px;"
                                                v-model="search.published_at_lte">
                                        </div>
                                    </div>
                                </div>
                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <span class="small">使用日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                type="date"
                                                class="form-control"
                                                @change="onChangeSearchUsedAtGte"
                                                style="min-width: 100px;"
                                                v-model="search.used_at_gte">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                type="date"
                                                class="form-control"
                                                @change="onChangeSearchUsedAtLte"
                                                style="min-width: 100px;"
                                                v-model="search.used_at_lte">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="inProgress && userCoupons === null"
                            class="p-5 d-flex justify-content-center align-items-center">
                            <b-spinner variant="yokumiru-admin"/>
                        </div>
                        <div
                            v-show="userCoupons !== null"
                            class="row justify-content-center">
                            <div class="col-md-12">
                                <b-table
                                    striped
                                    hover
                                    :items="userCoupons"
                                    :fields="fields"
                                    :sort-by.sync="$store.state.adminUserCoupons.sortBy"
                                    :sort-desc.sync="$store.state.adminUserCoupons.sortDesc"
                                    @sort-changed="fetchUserCoupons"
                                    responsive
                                    class="table-bordered m-table">
                                    <template v-slot:cell(id)="data">
                                        {{ data.item.id }}
                                    </template>

                                    <template v-slot:cell(name)="data">
                                        <div>{{ data.item.coupon.name }}</div>
                                        <div class="small text-muted">{{ data.item.campaign.name }}</div>
                                    </template>

                                    <template v-slot:cell(category)="data">
                                        <div>{{ couponCategoryFormat(data.item) }}</div>
                                    </template>

                                    <template v-slot:cell(user_full_name_kana)="data">
                                        <template v-if="data.item.user">
                                            <a href="#" @click="showModalUserProfile(data.item, $event)">
                                                {{ data.item.user.full_name }} <span class="small">({{data.item.user.age}})</span>
                                            </a>
                                            <div class="small">{{ data.item.user.full_name_kana }}</div>
                                        </template>
                                        <template v-else>
                                            <span class="text-muted">退会済の{{ $locale.patient }}</span>
                                        </template>
                                    </template>

                                    <template v-slot:cell(published_at)="data">
                                        <div class="u-palt">
                                            <span>{{ helper.dateForHuman( data.item.published_at, timezone, { simpleYear: true } ) }}</span><!--
                                            --><span
                                                class="small font-weight-bold"
                                                :class="helper.dayForHumanCSS( data.item.published_at, timezone)">
                                                {{ helper.dayForHuman( data.item.published_at, timezone, { bracket: true } ) }}
                                            </span><!--
                                            --><span>{{ helper.timeForHuman( data.item.published_at, timezone) }}</span>
                                        </div>
                                        <div class="small text-muted">使用期限:&nbsp;{{ expiredAtFormat(data.item) }}</div>
                                    </template>

                                    <template v-slot:cell(used_at)="data">
                                        <div v-if="data.item.used_at" class="u-palt">
                                            <span>{{ helper.dateForHuman( data.item.used_at, timezone, { simpleYear: true } ) }}</span><!--
                                         --><span
                                                class="small font-weight-bold"
                                                :class="helper.dayForHumanCSS( data.item.used_at, timezone)">
                                                {{ helper.dayForHuman( data.item.used_at, timezone, { bracket: true } ) }}
                                            </span><!--
                                         --><span>{{ helper.timeForHuman( data.item.used_at, timezone) }}</span>
                                        </div>
                                        <span v-else class="text-muted">-</span>
                                    </template>

                                    <template v-slot:cell(consultation_id)="data">
                                        <a
                                            v-if="data.item.consultation_id"
                                            :href="`/admin/consultations/${data.item.consultation_id}`">
                                            {{ `#${data.item.consultation_id}` }}
                                        </a>
                                        <span v-else class="text-muted">-</span>
                                    </template>

                                    <template v-slot:cell(invoice_id)="data">
                                        <a
                                            v-if="data.item.invoice_id"
                                            :href="`/admin/invoices?freeword=${data.item.invoice_id}`">
                                            {{ `#${data.item.invoice_id}` }}
                                        </a>
                                        <span v-else class="text-muted">-</span>
                                    </template>

                                    <template v-slot:cell(status)="data">
                                        <div :class="{ 'text-success' : data.item.status === userCouponStatus.used }">
                                            {{ statusNameFormat(data.item) }}
                                        </div>
                                    </template>
                                </b-table>

                                <div
                                    v-if="!asUserProfile"
                                    class="d-flex flex-wrap justify-content-between align-items-center">
                                    <b-pagination
                                        :total-rows="$store.state.adminUserCoupons.total"
                                        :per-page="$store.state.adminUserCoupons.per_page"
                                        v-model="$store.state.adminUserCoupons.current_page"
                                        @change="fetchUserCoupons">
                                    </b-pagination>

                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="mr-3 mb-3">
                                            <span class="small">{{ dispPaginationDetail }}</span>
                                        </div>
                                        <div class="mb-3">
                                            <b-button
                                                variant="yokumiru-orange"
                                                @click="downloadCSV"
                                                :disabled="inProgress">
                                                CSVダウンロード
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <admin-user-profile-modal
            v-if="!asUserProfile"
            :timezone="timezone">
        </admin-user-profile-modal>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import YokumiruHelper from '../../YokumiruHelper'
    import { sprintf } from 'sprintf-js'
    import { mapMutations } from 'vuex'

    export default {
        name: 'AdminUserCoupons',

        props: {
            user: {
                type: Object,
                default: null,
            },
            paginate: {
                type: Boolean,
                default: true,
            },
            isClearSearchCondition: {
                type: Boolean,
                default: true,
            },
            asUserProfile: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                timezone: 'Asia/Tokyo',
                couponCategory: constants.couponCategory,
                userCouponStatus: constants.user_coupons,
                search: {
                    freeword: '',
                    category: null,
                    published_at_gte: null,
                    published_at_lte: null,
                    used_at_gte: null,
                    used_at_lte: null,
                },
                userCoupons: null,
                fields: [
                    {
                        key: 'id',
                        label: '#',
                        sortable: true,
                    },
                    {
                        key: 'name',
                        label: 'クーポン名',
                        sortable: true,
                    },
                    {
                        'key': 'category',
                        'label': 'タイプ',
                        sortable: true,
                    },
                    {
                        key: 'published_at',
                        label: '発行日時',
                        sortable: true,
                    },
                    {
                        key: 'used_at',
                        label: '使用日時',
                        sortable: true,
                    },
                    {
                        'key': 'consultation_id',
                        'label': `${this.$locale.consultation_host}ID`,
                        sortable: true,
                    },
                    {
                        key: 'invoice_id',
                        label: '請求ID',
                        sortable: true,
                    },
                    {
                        key: 'status',
                        label: 'ステータス',
                        sortable: true,
                    },
                ],
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                    from: 0,
                    to: 0,
                },
                sortBy: 'id',
                sortDesc: true,
            }
        },

        computed: {
            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if (this.$store.state.adminUserCoupons.total < 1) {
                    return ''
                }

                return `全${this.$store.state.adminUserCoupons.total}件中 ${this.$store.state.adminUserCoupons.from}～${this.$store.state.adminUserCoupons.to}件表示`
            },
        },

        created: function () {
            this.initQueryFromState()
            this.initSearchCondition()
            this.fetchUserCoupons()
            bus.$on('user-coupon-deleted', this.fetchUserCoupons)

            if (this.asUserProfile) {
                this.fields.forEach((field) => field.sortable = false)
            }
            else {
                this.fields.splice(3, 0, {
                    'key': 'user_full_name_kana',
                    'label': `${this.$locale.patient}名`,
                    sortable: true,
                })
            }
        },

        methods: {
            ...mapMutations({
                setQuery: 'adminUserCoupons/setQuery',
                setQueries: 'adminUserCoupons/setQueries',
                clearQueries: 'adminUserCoupons/clearQueries',
            }),

            onChangeSearchFreeword: async function () {
                await this.setQuery({ key: 'freeword', value: this.search.freeword })
                await this.fetchUserCoupons(1)
            },

            onChangeSearchCategory: async function () {
                await this.setQuery({ key: 'category', value: this.search.category })
                await this.fetchUserCoupons(1)
            },

            onChangeSearchPublishedAtGte: async function () {
                await this.setQuery({ key: 'published_at_gte', value: this.search.published_at_gte })
                await this.fetchUserCoupons(1)
            },

            onChangeSearchPublishedAtLte: async function () {
                await this.setQuery({ key: 'published_at_lte', value: this.search.published_at_lte })
                await this.fetchUserCoupons(1)
            },

            onChangeSearchUsedAtGte: async function () {
                await this.setQuery({ key: 'used_at_gte', value: this.search.used_at_gte })
                await this.fetchUserCoupons(1)
            },

            onChangeSearchUsedAtLte: async function () {
                await this.setQuery({ key: 'used_at_lte', value: this.search.used_at_lte })
                await this.fetchUserCoupons(1)
            },

            /**
             * 発行クーポン一覧
             *
             * @param {number|object} param
             */
            fetchUserCoupons: async function (param = null) {
                if (this.inProgress) return
                this.inProgress = true

                this.userCoupons = null

                if (Number.isInteger(param) && param > 0) {
                    await this.setQuery({ key: 'current_page', value: param })
                }
                else if (param !== null && param.hasOwnProperty('sortBy')) {
                    await this.setQuery({ key: 'sortBy', value: param.sortBy })
                    await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
                }

                const endpoint = constants.admin.user_coupons.endpoint.base

                axios.get(`${endpoint}${this.buildQuery(this.paginate)}`)
                    .then(({data}) => {
                        this.userCoupons = data.data
                        if (data.meta) this.setQueries(data.meta)
                    })

                this.inProgress = false
            },

            /**
             * 検索条件の初期化（localStorageから復元）
             */
            initQueryFromState: function () {
                if (!this.isClearSearchCondition) {
                    this.clearQueries()
                    return
                }

                if (localStorage.getItem('yokumiruWeb')) {
                    const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                    if (data.adminUserCoupons) {
                        this.setQueries(data.adminUserCoupons)
                    }
                }
            },

            /**
             * 検索条件の初期化
             */
            initSearchCondition: function () {
                if (this.isClearSearchCondition) return

                this.search.freeword = this.$store.state.adminUserCoupons.freeword
                this.search.category = this.$store.state.adminUserCoupons.category
                this.search.published_at_gte = this.$store.state.adminUserCoupons.published_at_gte
                this.search.published_at_lte = this.$store.state.adminUserCoupons.published_at_lte
                this.search.used_at_gte = this.$store.state.adminUserCoupons.used_at_gte
                this.search.used_at_lte = this.$store.state.adminUserCoupons.used_at_lte
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function (paginate = true) {
                let query = '?'

                if (paginate) {
                    query += `page=${this.$store.state.adminUserCoupons.current_page}`
                    query += `&sort=${this.$store.state.adminUserCoupons.sortBy}`
                    query += `&desc=${this.$store.state.adminUserCoupons.sortDesc}`
                }
                else {
                    query += `sort=${this.$store.state.adminUserCoupons.sortBy}`
                    query += `&desc=${this.$store.state.adminUserCoupons.sortDesc}`
                }

                query += `&freeword=${this.$store.state.adminUserCoupons.freeword || ''}`
                query += `&category=${this.$store.state.adminUserCoupons.category || ''}`
                query += `&published_at_gte=${this.$store.state.adminUserCoupons.published_at_gte || ''}`
                query += `&published_at_lte=${this.$store.state.adminUserCoupons.published_at_lte || ''}`
                query += `&used_at_gte=${this.$store.state.adminUserCoupons.used_at_gte || ''}`
                query += `&used_at_lte=${this.$store.state.adminUserCoupons.used_at_lte || ''}`

                if (this.user) {
                    query += `&user_id=${this.user.id}`
                }

                return query
            },

            /**
             * 使用期限の表記
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredAtFormat: function (user_coupon) {
                if (user_coupon.expired_at === '2100-01-01 00:00:00') {
                    return '無期限'
                }
                else if (!user_coupon.expired_at) {
                    return '未取得'
                }
                return this.helper.dateForHuman(user_coupon.expired_at , this.timezone)
            },

            /**
             * ステータスの表記
             *
             * @param {object} user_coupon
             * @return {string}
             */
            statusNameFormat: function (user_coupon) {
                let result = this.userCouponStatus.all.find(status => {
                    return status.value === user_coupon.status
                })

                return result ? result.text : ''
            },

            /**
             * クーポンタイプの表記
             *
             * @param {object} coupon
             * @return {string}
             */
            couponCategoryFormat: function (coupon) {
                if (coupon.category === constants.couponCategory.consultation) {
                    return this.$locale.consultation_host
                }
                else if (coupon.category === constants.couponCategory.plan) {
                    return 'サービス'
                }
                return ''
            },

            /**
             * 会員詳細モーダル表示
             */
            showModalUserProfile: function (user_coupon, event) {
                event.preventDefault();
                bus.$emit(
                    'open-modal-admin-user-profile',
                    user_coupon.user_id,
                    user_coupon.consultation_id
                );
            },

            /**
             * CSVダウンロード
             */
            downloadCSV: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.admin.user_coupons.endpoint.base
                const options = { responseType : 'blob' }

                await axios.get(`${endpoint}/export${this.buildQuery(this.paginate)}`, options)
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: response.data.type,
                        })
                        saveAs(
                            blob,
                            sprintf(
                                '発行クーポン一覧_%s.csv',
                                moment().format('YYYYMMDD')
                            )
                        )
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },
        },
    };
</script>

<style lang="scss">
.p-user-coupons {
    table {
        font-size: 0.75rem;

        th:nth-child(3) {
            max-width: 90px;
        }
    }
}
</style>
